initslide();

$(document).on('shopify:section:load', function(event) {
  initslide();
});
$(document).on('shopify:section:unload', function(event) {
 initslide();
});
function initslide() {
    $('.M-video-slider').slick({
    infinite: true,
    speed: 400,
    autoplay: true,
    slidesToShow: 5,
    pauseOnHover: true,
    slidesToScroll: 1,
    arrows: true,
    autoplaySpeed: 5000,
    dots: false,
      responsive: [ 
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4
        }
      },
        {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  });
}
var ProductZoomButton = class extends HTMLButtonElement {
  constructor() {
    super();
    this.addEventListener("click", this.onButtonClicked.bind(this));
  }
  
  onButtonClicked(event) {
    // Completely prevent all event handling
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    
    // Capture necessary data before any slide movement occurs
    const mediaItem = this.closest(".product-gallery__media");
    let mediaIndex;
    let swiperInstance = null;
    const swiperContainer = mediaItem.closest('.swiper');
    
    if (swiperContainer && window.mgSwiper) {
      swiperInstance = window.mgSwiper;
      const clickedSlide = this.closest('.swiper-slide');
      mediaIndex = Array.from(swiperContainer.querySelectorAll('.swiper-slide')).indexOf(clickedSlide);
      
      // Store current index globally
      window.lastZoomSlideIndex = mediaIndex;
      
      // Temporarily disable transitions and swiping
      const originalTransition = swiperInstance.params.speed;
      const originalAllowTouchMove = swiperInstance.params.allowTouchMove;
      swiperInstance.params.speed = 0;
      swiperInstance.params.allowTouchMove = false;
      
      // Set a timeout to restore these settings
      setTimeout(() => {
        swiperInstance.params.speed = originalTransition;
        swiperInstance.params.allowTouchMove = originalAllowTouchMove;
      }, 500);
    } else {
      const carousel = this.closest("media-carousel");
      const visibleImages = Array.from(carousel.visibleItems).filter(
        item => item.getAttribute("data-media-type") === "image"
      );
      mediaIndex = visibleImages.indexOf(mediaItem);
      window.lastZoomSlideIndex = mediaIndex;
    }
    
    // Dispatch after a small delay to ensure our prevention is applied
    setTimeout(() => {
      this.dispatchEvent(new CustomEvent("lightbox:open", {
        bubbles: true,
        detail: { index: mediaIndex }
      }));
    }, 10);
  }
};

// Modify Swiper initialization
function initmgswiper() {
  console.log("Function Started");
  var swiper = new Swiper(".mgswiper", {
    slidesPerView: 1.2,
    spaceBetween: 5,
    slideToClickedSlide: false,
    allowTouchMove: true,
    touchStartPreventDefault: false,
    preventClicks: true,
    preventClicksPropagation: true,
    touchReleaseOnEdges: true,
    watchSlidesProgress: true,
    watchOverflow: true,
    observer: true,
    observeParents: true,
    on: {
      // Add event handlers to maintain proper slide index
      beforeTransitionStart: function(swiper, speed, internal) {
        // Store the target index if it's not a zoom operation
        if (!window.isZoomOperation) {
          window.lastIntendedSlideIndex = swiper.activeIndex;
        }
      },
      slideChange: function(swiper) {
        // Check if this change is due to a zoom operation
        if (window.isZoomOperation) {
          // If so, prevent it by going back to the original slide
          if (window.lastZoomSlideIndex !== undefined) {
            swiper.slideTo(window.lastZoomSlideIndex, 0, false);
          }
        }
      }
    },
    navigation: {
      nextEl: ".m-mg-next",
      prevEl: ".m-mg-prev",
    },
    breakpoints: {
      600: {
        slidesPerView: 2,
        spaceBetween: 5,
      },
      0: {
        slidesPerView: 1.4,
        spaceBetween: 5,
      },
    },
  });
  window.mgSwiper = swiper;
  
  // Handle lightbox events
  document.addEventListener("lightbox:open", function() {
    window.isZoomOperation = true;
  }, false);
  
  document.addEventListener("lightbox:close", function() {
    if (window.mgSwiper && window.lastZoomSlideIndex !== undefined) {
      // Force the swiper to maintain the correct slide
      window.mgSwiper.slideTo(window.lastZoomSlideIndex, 0, false);
      
      // Clear the zoom flag after a brief timeout
      setTimeout(() => {
        window.isZoomOperation = false;
      }, 100);
    }
  }, false);
}

// Initialize these global flags
window.isZoomOperation = false;
window.lastZoomSlideIndex = undefined;
window.lastIntendedSlideIndex = undefined;

